<template>
  <div class="d-flex flex-row">
    <InsightsExport
      :disabled="disableFilters || emptyData"
      use-lighter-color
    />
    <InsightsShare
      class="ml-2"
      :disabled="disableFilters || emptyData"
      use-lighter-color
    />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useInsights } from '@/stores/insights/insights';
import InsightsExport from '@/components/insights/ExportModal/InsightsExport.vue';
import InsightsShare from '@/components/insights/ShareModal/InsightsShare.vue';

// Stores
const insightsStore = useInsights();
const { emptyData } = storeToRefs(insightsStore);

defineProps({
  shareable: { type: Boolean, default: false },
  disableFilters: { type: Boolean, default: false },
});
</script>
